/*! @azure/msal-common v15.3.0 2025-03-20 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "15.3.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
